/** The portal's own icons for its phone and iPad screens: 24px line glyphs drawn in the current colour. */
const PATHS = {
  home: "M3 11l9-8 9 8M5 10v10h14V10",
  people: "M9 5a3 3 0 110 6 3 3 0 010-6zM3 20c0-3 3-5 6-5s6 2 6 5M17 8h4M19 6v4",
  image: "M5 4h14a2 2 0 012 2v12a2 2 0 01-2 2H5a2 2 0 01-2-2V6a2 2 0 012-2zM9 8a2 2 0 110 4 2 2 0 010-4zM21 16l-5-5-9 9",
  coin: "M12 3a9 9 0 110 18 9 9 0 010-18zM15 9a3 3 0 00-3-1.5c-1.7 0-3 .9-3 2.2 0 3 6 1.6 6 4.6 0 1.3-1.3 2.2-3 2.2A3 3 0 019 15M12 6v1.5M12 16.5V18",
  user: "M12 4a4 4 0 110 8 4 4 0 010-8zM4 21c0-4 4-6 8-6s8 2 8 6",
  link: "M10 14a4 4 0 005.7 0l3-3a4 4 0 00-5.7-5.7l-1 1M14 10a4 4 0 00-5.7 0l-3 3a4 4 0 005.7 5.7l1-1",
  copy: "M10 8h8a2 2 0 012 2v8a2 2 0 01-2 2h-8a2 2 0 01-2-2v-8a2 2 0 012-2zM16 8V5a1 1 0 00-1-1H5a1 1 0 00-1 1v10a1 1 0 001 1h3",
  chevD: "M6 9l6 6 6-6",
  cal: "M5 5h14a2 2 0 012 2v12a2 2 0 01-2 2H5a2 2 0 01-2-2V7a2 2 0 012-2zM3 10h18M8 3v4M16 3v4",
  check: "M5 12.5l4.5 4.5L19 7",
  clock: "M12 3a9 9 0 110 18 9 9 0 010-18zM12 7v5l3 2",
  plus: "M12 5v14M5 12h14",
  search: "M11 4.5a6.5 6.5 0 110 13 6.5 6.5 0 010-13zM20 20l-4.2-4.2",
  folder: "M3 7a2 2 0 012-2h4l2 2h8a2 2 0 012 2v8a2 2 0 01-2 2H5a2 2 0 01-2-2z",
  download: "M12 4v11M7 10l5 5 5-5M5 20h14",
  wallet: "M4 7a2 2 0 012-2h12v4M5 8h14a2 2 0 012 2v8a2 2 0 01-2 2H5a2 2 0 01-2-2v-8a2 2 0 012-2zM16 14h2",
  file: "M6 3h8l4 4v14H6zM14 3v4h4",
  lock: "M7 11h10a2 2 0 012 2v6a2 2 0 01-2 2H7a2 2 0 01-2-2v-6a2 2 0 012-2zM8 11V8a4 4 0 018 0v3",
  grid: "M4.5 3h4A1.5 1.5 0 0110 4.5v4A1.5 1.5 0 018.5 10h-4A1.5 1.5 0 013 8.5v-4A1.5 1.5 0 014.5 3zM15.5 3h4A1.5 1.5 0 0121 4.5v4a1.5 1.5 0 01-1.5 1.5h-4A1.5 1.5 0 0114 8.5v-4A1.5 1.5 0 0115.5 3zM4.5 14h4a1.5 1.5 0 011.5 1.5v4A1.5 1.5 0 018.5 21h-4A1.5 1.5 0 013 19.5v-4A1.5 1.5 0 014.5 14zM15.5 14h4a1.5 1.5 0 011.5 1.5v4a1.5 1.5 0 01-1.5 1.5h-4a1.5 1.5 0 01-1.5-1.5v-4a1.5 1.5 0 011.5-1.5z",
  sun: "M12 8a4 4 0 110 8 4 4 0 010-8zM12 3v2M12 19v2M3 12h2M19 12h2M5.6 5.6l1.4 1.4M17 17l1.4 1.4M18.4 5.6L17 7M7 17l-1.4 1.4",
  moon: "M21 12.8A9 9 0 1111.2 3a7 7 0 009.8 9.8z",
  camera: "M4 8h3l2-2h6l2 2h3v11H4zM12 9.8a3.2 3.2 0 110 6.4 3.2 3.2 0 010-6.4z",
  x: "M6 6l12 12M18 6L6 18",
  dots: "M5 10.5a1.5 1.5 0 110 3 1.5 1.5 0 010-3zM12 10.5a1.5 1.5 0 110 3 1.5 1.5 0 010-3zM19 10.5a1.5 1.5 0 110 3 1.5 1.5 0 010-3z",
  play: "M8 5v14l11-7z",
  chart: "M4 19V5M4 19h16M8 16l3.5-4 3 2.5L20 8",
  info: "M12 3a9 9 0 110 18 9 9 0 010-18zM12 11v5M12 7.5v.5",
  undo: "M20 8a8 8 0 10.5 5M20 4v4h-4",
  doc: "M7 3h7l4 4v14a1 1 0 01-1 1H7a1 1 0 01-1-1V4a1 1 0 011-1zM14 3v4h4",
} as const;

export type IconName = keyof typeof PATHS;

export function Icon({ name, className }: { name: IconName; className?: string }) {
  return (
    <svg viewBox="0 0 24 24" className={className} aria-hidden="true">
      <path d={PATHS[name]} />
    </svg>
  );
}
